module.exports = __webpack_public_path__ + "img/20180815_145537_018.4b00e921.jpg";